// extracted by mini-css-extract-plugin
export default {"root":"fHDyw__root","marker":"LimNT__marker"};